/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SelectInTableComponent} from './select-in-table.component';
import {NgbDatepickerModule, NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {TreeDropdownComponent} from './tree-dropdown/tree-dropdown.component';
import {PipesModule} from '../pipes/pipes.module';
import {PrettyPrintReferencePipe} from '../pipes/pretty-print-reference/pretty-print-reference.pipe';
import {SelectInTableDropdownComponent} from './select-in-table-dropdown/select-in-table-dropdown.component';
import {ReactiveFormsModule} from '@angular/forms';
import {TooltipModule} from '../tooltip/tooltip.module';
import {InputModule} from '../input/input.module';

/**
 * @deprecated This module will be deleted in the future.
 */
@NgModule({
    imports: [
        CommonModule,
        NgbDropdownModule,
        PipesModule,
        ReactiveFormsModule,
        NgbDatepickerModule,
        TooltipModule,
        InputModule,

    ],
    exports: [
        SelectInTableComponent
    ],
    providers: [PrettyPrintReferencePipe],
    declarations: [SelectInTableComponent, TreeDropdownComponent, SelectInTableDropdownComponent]
})
export class SelectInTableModule {
}
